import { retrieveAccessToken } from './msal-config';


export async function authHeader() {
    try {
        const oauthToken = await retrieveAccessToken(null); // Wait for the token to be assigned
        if (oauthToken) {
            return { Authorization: 'Bearer ' + oauthToken };
        } else {
            console.warn("No token retrieved.");
            return {};
        }
    } catch (error) {
        console.error("Error retrieving access token:", error);
        return {};
    }
}